<template>
  <div class="products-page">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="img-and-text">
        <img class="row-1-top-img" src="../../assets/img/products/img1.jpg" alt>
        <div class="text-group">
          <h3 class="text-accent">{{ $t('products-1') }}</h3>
          <h1>{{ $t('products') }}</h1>
          <h2>{{ $t('products-2') }}</h2>
          <ul>
            <li>
              <router-link class="link-basic" to="/products?page=zn">{{ $t('products-3-1') }}</router-link>
            </li>
            <li>
              <router-link class="link-basic" to="/products?page=pb">{{ $t('products-3-2') }}</router-link>
            </li>
            <li>
              <router-link class="link-basic" to="/products?page=au">{{ $t('products-3-3') }}</router-link>
            </li>
            <li>
              <router-link class="link-basic" to="/products?page=ag">{{ $t('products-3-4') }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="products-chart">
        <canvas id="myChart"></canvas>
        <br>
        <h3 class="center">{{ $t('products-chart-1-title') }}</h3>
      </div>
      <img
        class="products-chart-mobile"
        src="../../assets/img/products/chart_products.png"
        alt="Chart"
      >
    </div>
    <div class="row row-2">
      <img src="../../assets/img/products/barrel.jpg" alt="Barrel">
      <div class="text-group">
        <h3 class="text-accent">{{ $t('products-5') }}</h3>
        <h1>{{ $t('products-6') }}</h1>
        <h2>{{ $t('products-7') }}</h2>
        <ul>
          <li>{{ $t('products-8') }}</li>
          <li>{{ $t('products-9') }}</li>
          <li>{{ $t('products-10') }}</li>
          <li>{{ $t('products-11') }}</li>
          <li>{{ $t('products-12') }}</li>
          <li>{{ $t('products-13') }}</li>
        </ul>
      </div>
    </div>
    <ProductsChart/>
    <VideoGallery/>
    <!-- <AdditionalInfo :text2="$t('about-10')"/> -->
  </div>
</template>

<script>
import Chart from "chart.js";
// eslint-disable-next-line
import ChartLabels from "chartjs-plugin-labels";
import ProductsChart from "./ProductsChart";
import VideoGallery from "../shared/VideoGallery";
// import AdditionalInfo from "../about/AdditionalInfo";
export default {
  components: {
    ProductsChart,
    VideoGallery,
    // AdditionalInfo
  },
  mounted() {
    Chart.defaults.global.animation.duration = 1000;
    Chart.defaults.global.animation.easing = "easeInOutQuart";
    const ctx = document.getElementById("myChart");
    new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: [
          this.$t("zn-and-cgg"),
          this.$t("precious-metals"),
          this.$t("pb-and-alloys"),
          this.$t("others")
        ],
        datasets: [
          {
            data: [48.92, 8.88, 39.97, 2.23],
            backgroundColor: ["#67aaae", "#d5ab45", "#f58220", "#cecece"],
            borderColor: ["#fff"],
            borderWidth: 10
          }
        ]
      },
      options: {
        responsive: true,
        legend: {
          display: false
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          labels: {
            render: "label",
            fontColor: "#000",
            fontFamily: "'Rubik'",
            fontSize: 14,
            arc: true,
            position: "outside",
            outsidePadding: 10,
            textMargin: 10
          }
        }
      }
    });
    if (this.$route.query.scroll) {
      setTimeout(() => {
        const targetElement = document.getElementById(this.$route.query.scroll);
        targetElement.scrollIntoView({ behavior: "smooth" });
      }, 1500);
    }
  }
};
</script>
<style lang="scss" scoped>
.products-page {
  position: relative;
  .row-1 {
    .products-chart {
      padding: 0 0 50px;
      position: absolute;
      right: 0;
      width: 60%;
    }
  }
  .row-2 {
    align-items: center;
    margin-bottom: -50px;
    img {
      height: auto;
      width: 45%;
    }
    .text-group {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-bottom: 50px;
      padding-left: $sidesPadding / 2;
      width: 40%;
    }
  }
}
.products-chart-mobile {
  display: none;
}
@media screen and (max-width: 1600px) {
  .products-page {
    .row-2 {
      .text-group {
        padding-left: $sidesPadding1600 / 2;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .products-page {
    .row-1 {
      flex-direction: column;
      padding: 0;
      .text-group {
        margin: 0;
        padding: $sidesPadding1280;
      }
      .img-and-text {
        width: 100%;
        img {
          display: none;
        }
      }
      .products-chart {
        position: static;
        width: 100%;
      }
    }
    .row-2 {
      flex-direction: column;
      margin-bottom: initial;
      img {
        width: 100%;
      }
      .text-group {
        padding: $sidesPadding1280;
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .products-page {
    .row-1 {
      .text-group {
        padding: $sidesPadding600;
      }
      .products-chart {
        display: none;
      }
      .products-chart-mobile {
        display: block;
        height: auto;
        margin: 15px 0;
        width: 100%;
      }
    }
    .row-2 {
      .text-group {
        padding: $sidesPadding600;
      }
    }
  }
}
</style>